export function getDraftOwnerId(payload) {
  if (!payload || typeof payload !== "object") return "";
  return String(payload.__ownerUserId || payload.ownerUserId || "").trim();
}

export function isOwnedDraftForUser(payload, userId = "") {
  const uid = String(userId || "").trim();
  if (!uid) return false;
  return getDraftOwnerId(payload) === uid;
}

export function selectOwnedDraft(payload, userId = "", fallback = null) {
  return isOwnedDraftForUser(payload, userId) ? payload : fallback;
}
